/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialSupportDemoCreditDto } from '../../models/financial-support-demo-credit-dto';

export interface FinancialSupportDemoControllerFindCredit$Params {
  id: string;
}

export function financialSupportDemoControllerFindCredit(http: HttpClient, rootUrl: string, params: FinancialSupportDemoControllerFindCredit$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportDemoCreditDto>> {
  const rb = new RequestBuilder(rootUrl, financialSupportDemoControllerFindCredit.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FinancialSupportDemoCreditDto>;
    })
  );
}

financialSupportDemoControllerFindCredit.PATH = '/api/financial-support/demo-companies/{id}/credit';
